import React from 'react';

const AnimatedBanner = () => (
  <div className="animated-message text-center">
    Time to Renew & Stay Covered! 🚗✨ <br />
    Renew your motor policy in just a click and stay protected on the road.
    Avoid last-minute hassles – secure your coverage now! 🔒✅
  </div>
);

export default AnimatedBanner;
